import React from 'react';
import { IconSpinner } from '../../../components';
import PageLayout from '../components/PageLayout';

export default ({ intl, scrollingDisabled, noIndexTag }) => {
    const loadingTitle = intl.formatMessage({
        id: 'ListingPage.loadingListingTitle',
    });

    return (
        <PageLayout
            /** no topbar when loading is in progress  */
            showTopBar={false}
            title={loadingTitle}
            scrollingDisabled={scrollingDisabled}
            metaTags={noIndexTag}
        >
            <IconSpinner />
        </PageLayout>
    );
};
